export default __webpack_public_path__ + "static/CharlieDisplay-Thin-7886757415d29d6f16db106f3bdb2840.otf";